import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import moment from 'moment-timezone/builds/moment-timezone-with-data-1970-2030.min.js';

import { PortalApiService } from '../../core/portal-api.service';
import { PortalAuthService } from '../../core/portal-auth.service';
import { PortalStateService } from '../../core/portal-state.service';
import { I18nService } from '../../core/i18n.service';
import { buildMonths, formatMonth } from '../../core/months';

@Component({
  selector: 'portal-overview',
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.css']
})
export class OverviewComponent implements OnInit, OnDestroy {

  loading = true;
  error = '';
  summary: any = null;
  month = moment().format('YYYY-MM');
  groups: any[] = [];

  private sub: Subscription;

  constructor(
    private api: PortalApiService,
    private auth: PortalAuthService,
    private state: PortalStateService,
    public i18n: I18nService
  ) { }

  ngOnInit() {
    this.sub = this.state.customerId$.subscribe(() => this.load());
  }

  ngOnDestroy() { if (this.sub) { this.sub.unsubscribe(); } }

  get monthLabel(): string { return formatMonth(this.month, this.i18n.lang); }

  monthOptionLabel(value: string): string { return formatMonth(value, this.i18n.lang); }

  // Only the current and previous 11 months — the portal is an operational
  // tool, not an archive, and anything older is a billing question.
  //
  // Built ONCE into a field, never exposed as a getter. A getter here returns
  // freshly minted objects on every call, so *ngFor's identity tracking treats
  // all 12 <mat-option>s as new on every change-detection pass, destroys and
  // recreates them, and each re-registration schedules another pass — an
  // unbounded loop that locks up the browser tab.
  readonly months: { value: string }[] = buildMonths();

  async load() {
    this.loading = true;
    this.error = '';
    const from = moment(this.month, 'YYYY-MM').startOf('month').unix();
    const to = moment(this.month, 'YYYY-MM').endOf('month').unix();
    try {
      const res: any = await this.api.summary(from, to, this.state.customerId || undefined);
      this.summary = res;
      const session = this.auth.session;
      const scope = this.state.customerId;
      this.groups = ((session && session.groups) || [])
        .filter((g: any) => !scope || g.customerId === scope);
    } catch (err: any) {
      this.error = (err && err.error && err.error.message) || 'Could not load the overview.';
    }
    this.loading = false;
  }

  onMonthChange(month: string) {
    this.month = month;
    this.load();
  }

  kr(v: number): string {
    return (Number(v) || 0).toLocaleString('nb-NO', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
}
